<div *ngIf="benefit.description">
  <span class="text-primary">{{ 'common.description' | translate }}:</span>
  {{ benefit.description }}
</div>
<div *ngIf="benefit.place_of_service">
  <span class="text-primary">
    {{ 'patient-details.eligibility-card.place-of-service' | translate }}:
  </span>
  {{ benefit.place_of_service | titlecase }}
</div>
<div *ngIf="benefit.eligibility_date">
  <span class="text-primary">
    {{ 'patient-details.eligibility-card.eligibility-date' | translate }}:
  </span>
  {{ benefit.eligibility_date }}
</div>
<div *ngIf="benefit.place_of_service">
  <span class="text-primary">
    {{ 'patient-details.eligibility-card.place-of-service' | translate }}:
  </span>
  {{ benefit.place_of_service | titlecase }}
</div>
<div *ngIf="benefit.plan_begin_date">
  <span class="text-primary">
    {{ 'patient-details.eligibility-card.plan-begin-date' | translate }}:
  </span>
  {{ benefit.plan_begin_date }}
</div>
<div *ngIf="benefit.plan_end_date">
  <span class="text-primary">
    {{ 'patient-details.eligibility-card.plan-end-date' | translate }}:
  </span>
  {{ benefit.plan_end_date }}
</div>
<div *ngIf="benefit.delivery">
  <span class="text-primary">
    {{ 'patient-details.eligibility-card.delivery' | translate }}:
  </span>
  {{ benefit.delivery | json }}
</div>
<mmx-eligibility-messages [messages]="benefit.messages"></mmx-eligibility-messages>
